import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'app-sfl-input',
    templateUrl: './sfl-input.component.html',
    styleUrl: './sfl-input.component.scss',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SflInputComponent),
            multi: true,
        },
    ],
})
export class SflInputComponent {
    @Input() type: 'text' | 'number' | 'password' | 'email' = 'text';
    @Input() label?: string;
    @Input() placeholder?: string;
    @Input() disabled = false;

    value: string | number = '';

    onChange: (value: string | number) => void = () => {};
    onTouched: () => void = () => {};

    writeValue(value: string | number): void {
        this.value = value;
    }

    registerOnChange(fn: (value: string | number) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }
}
